import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBrain,
  faDesktop,
  faCloud,
  faCreditCard,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";

import { SEO } from "../components/SEO";

const aiFeatures = [
  "Agentic AI pipeline design and deployment",
  "LLM integration into existing workflows",
  "Predictive analytics and anomaly detection",
  "AI governance frameworks and responsible AI policies",
  "Code review and test generation automation",
  "Executive AI strategy and roadmap consulting",
];

const remoteFeatures = [
  "Windows, macOS, and Linux support",
  "System cleanup and performance optimization",
  "Software installation and configuration",
  "Network and connectivity troubleshooting",
  "Performance optimization",
  "Encrypted, secure remote sessions",
];

const hostingFeatures = [
  "Domain name registration and management",
  "Shared and dedicated hosting plans",
  "SSL certificate setup and renewal",
  "DNS configuration and management",
  "Website migration and setup assistance",
  "Ongoing hosting management support",
];

const FeatureList = ({ items }) => (
  <div className="row g-3">
    {items.map((item, i) => (
      <div className="col-md-6" key={i}>
        <div className="service-feature">
          <FontAwesomeIcon icon={faCircleCheck} className="service-check" />
          {item}
        </div>
      </div>
    ))}
  </div>
);

export const Services = () => {
  return (
    <>
      <SEO
        title="IT Services — AI, Remote Support, Cloud & Hosting"
        description="Professional IT services from TechGuyDom: agentic AI consulting, secure remote computer support for Windows/macOS/Linux, Azure cloud architecture, and domain & hosting."
        path="/services"
      />
      {/* Page Header */}
      <div className="page-header-section">
        <h1>Services</h1>
        <p className="page-header-sub">
          Professional IT services tailored to your needs — from quick fixes to
          enterprise-scale solutions.
        </p>
      </div>

      <div className="container services-detail-section">
        {/* AI Solutions */}
        <div className="service-detail-block">
          <div className="row g-4 align-items-start">
            <div className="col-auto">
              <FontAwesomeIcon icon={faBrain} className="service-detail-icon" />
            </div>
            <div className="col">
              <h3 className="section-title mb-1 mt-0">AI Solutions</h3>
              <p className="text-muted mb-4">
                Strategic AI consulting and hands-on implementation for
                organizations ready to harness the power of artificial
                intelligence.
              </p>
              <FeatureList items={aiFeatures} />
              <div className="mt-4">
                <a
                  href="https://bsky.app/profile/techguydom.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Reach Out to Get Started
                </a>
              </div>
            </div>
          </div>
        </div>

        <hr className="section-divider" />

        {/* Remote Support */}
        <div className="service-detail-block">
          <div className="row g-4 align-items-start">
            <div className="col-auto">
              <FontAwesomeIcon
                icon={faDesktop}
                className="service-detail-icon"
              />
            </div>
            <div className="col">
              <h3 className="section-title mb-1">Remote Support</h3>
              <p className="text-muted mb-4">
                Secure, fast, encrypted remote access to get your devices back
                on track without the hassle of an in-person visit.
              </p>
              <FeatureList items={remoteFeatures} />
              <div className="mt-4">
                <a
                  href="https://techguydom.screenconnect.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Connect Now
                </a>
              </div>
            </div>
          </div>
        </div>

        <hr className="section-divider" />

        {/* Domain & Hosting */}
        <div className="service-detail-block">
          <div className="row g-4 align-items-start">
            <div className="col-auto">
              <FontAwesomeIcon icon={faCloud} className="service-detail-icon" />
            </div>
            <div className="col">
              <h3 className="section-title mb-1">Domain & Hosting</h3>
              <p className="text-muted mb-4">
                Get your online presence established and running with affordable
                domain registration and reliable premium hosting.
              </p>
              <FeatureList items={hostingFeatures} />
              <div className="mt-4">
                <a
                  href="https://services.dommicro.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <hr className="section-divider" />

        {/* Make a Payment */}
        <div className="service-detail-block">
          <div className="row g-4 align-items-start">
            <div className="col-auto">
              <FontAwesomeIcon
                icon={faCreditCard}
                className="service-detail-icon"
              />
            </div>
            <div className="col">
              <h3 className="section-title mb-1">Make a Payment</h3>
              <p className="text-muted mb-4">
                Securely pay for services online — fast, simple, and
                hassle-free through our Square payment portal.
              </p>
              <a
                href="https://square.link/u/2HNpYE7l"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Pay Now via Square
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
